import { MDBSpinner } from 'mdb-react-ui-kit';
import React from 'react';
import './LoadingIndicator.scss';

function LoadingIndicator(props){
    if(props.show) {
        if(!props.fullScreen) {
            return <div className='loading-indicator'>
                <MDBSpinner size='lg' />
                {props.message && <span role='status' className='ms-2'>{props.message}</span>}
            </div>
        } else {
            return <div className='loading-indicator full-screen'>
                <MDBSpinner size='lg' />
                {props.message && <span role='status' className='ms-2'>{props.message}</span>}
            </div>
        }
    } else {
        return <></>
    }
}

export default LoadingIndicator;